import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sousuo_b",
  "use": "icon-sousuo_b-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sousuo_b\"><defs><style type=\"text/css\"></style></defs><path d=\"M917.12 820.48l-161.28-161.28a374.4 374.4 0 1 0-89.6 91.52l160 160a64 64 0 0 0 90.24-90.24zM285.44 625.28a236.16 236.16 0 1 1 334.08 0 236.16 236.16 0 0 1-334.08 0z\" p-id=\"14771\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol